var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.waitingScanResponse
        ? _c(
            "div",
            { attrs: { id: "waiting-screen" } },
            [_c("b-spinner", { staticClass: "spinner-color" })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ScanMenuModal", { on: { onValidateClicked: _vm.onValidateClicked } }),
      _vm._v(" "),
      _c("ScanResultModal", {
        attrs: {
          "is-success": _vm.isSuccess,
          "should-display-insist-button": _vm.shouldDisplayInsistButton,
          identifier: _vm.identifier,
          "has-gained-lampion": _vm.hasGainedLampion
        },
        on: {
          onVerifyClicked: function($event) {
            return _vm.goToVerifyMatch(false)
          },
          onInsistClicked: function($event) {
            return _vm.goToVerifyMatch(true)
          },
          onEndClicked: function($event) {
            return _vm.$bvModal.hide("scan-result-modal")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bf53440", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf53440","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/match/ScanMenu.vue
// module id = qhHV
// module chunks = 0